import { create } from "zustand";

import { PlayerCoupon } from "@/types/ApiResponses/Coupon";

interface CouponsState {
  savedCoupons: PlayerCoupon[];
  isSavingInProgress: boolean;
}

interface CouponsActions {
  setSavedCoupon(coupons: PlayerCoupon[]): void;
  setIsSavingInProgress(inProgress: boolean): void;
}

type CouponsStore = CouponsState & CouponsActions;

const defaultInitState: CouponsState = {
  savedCoupons: [],
  isSavingInProgress: false,
};

const useCouponsStore = create<CouponsStore>((set) => ({
  ...defaultInitState,
  setSavedCoupon(coupons) {
    set({ savedCoupons: coupons });
  },
  setIsSavingInProgress(inProgress) {
    set({ isSavingInProgress: inProgress });
  },
}));

export {
  useCouponsStore,
  defaultInitState,
  type CouponsStore,
  type CouponsState,
};
